import DiscussionFormConfirmation from "./js/DiscussionFormConfirmation";
export default DiscussionFormConfirmation;